import { EmptyState } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { ReportAccessDetailPaneStates } from '../../enums'

type ReportAccessDetailEmptyPaneState =
  | typeof ReportAccessDetailPaneStates.NO_PRIMARY_CATEGORIES
  | typeof ReportAccessDetailPaneStates.NO_SECONDARY_CATEGORIES
  | typeof ReportAccessDetailPaneStates.SECONDARY_CATEGORIES_ERROR
  | typeof ReportAccessDetailPaneStates.NO_SECONDARY_CATEGORY

const EMPTY_STATE_MESSAGES = {
  [ReportAccessDetailPaneStates.NO_PRIMARY_CATEGORIES]: {
    header: messages.noPrimaryCategoriesHeader,
    content: messages.noPrimaryCategoriesContent,
  },
  [ReportAccessDetailPaneStates.NO_SECONDARY_CATEGORIES]: {
    header: messages.noSecondaryCategoriesHeader,
    content: messages.noSecondaryCategoriesContent,
  },
  [ReportAccessDetailPaneStates.SECONDARY_CATEGORIES_ERROR]: {
    header: messages.secondaryCategoriesErrorHeader,
    content: messages.secondaryCategoriesErrorContent,
  },
  [ReportAccessDetailPaneStates.NO_SECONDARY_CATEGORY]: {
    header: messages.header,
    content: messages.content,
  },
}

export interface IReportAccessDetailEmptyStateProps {
  paneState: ReportAccessDetailEmptyPaneState
}

/**
 * Presentational Feature Set subcomponent — the detail card when there is no
 * SecondaryCategory to manage, so no grant control is offered without a
 * target. The copy names what is missing and never asks for an impossible
 * selection.
 */
export const ReportAccessDetailEmptyState = ({
  paneState,
}: IReportAccessDetailEmptyStateProps) => {
  const intl = useProcurifyIntl()
  const { header, content } = EMPTY_STATE_MESSAGES[paneState]

  return (
    <EmptyState
      small
      header={intl.formatMessage(header)}
      content={intl.formatMessage(content)}
    />
  )
}

ReportAccessDetailEmptyState.displayName = 'ReportAccessDetailEmptyState'
